<template>
  <div class="community-bell">
    <b-dropdown
      variant="link"
      toggle-class="text-decoration-none"
      no-caret
      right
      menu-class="bell-menu"
      @show="onOpen"
    >
      <template #button-content>
        <div class="bell-button">
          <i class="icon-notification-filled" />
          <span v-if="unreadCount > 0" class="bullet">{{
            unreadCountLabel
          }}</span>
        </div>
      </template>

      <div
        class="bell-header d-flex align-items-center justify-content-between px-3 py-2"
      >
        <strong>Notificações</strong>
        <button
          v-if="notifications.length"
          class="btn-link-action"
          @click="markAllRead"
        >
          Marcar todas como lidas
        </button>
      </div>

      <div v-if="loading" class="text-center py-3">
        <b-spinner variant="primary" small />
      </div>

      <template v-else>
        <b-dropdown-item
          v-for="notification in notifications"
          :key="notification.id"
          @click="onClickNotification(notification)"
        >
          <div class="notification-item d-flex align-items-start">
            <span v-if="!notification.read_at" class="dot mr-2" />
            <div class="flex-fill">
              <p class="mb-0">{{ describe(notification) }}</p>
              <small>{{ timeFromNow(notification.created_at) }}</small>
            </div>
          </div>
        </b-dropdown-item>

        <div v-if="!notifications.length" class="empty text-center py-3">
          Nenhuma notificação por aqui.
        </div>
      </template>
    </b-dropdown>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { timeFromNow } from "@/functions/helpers";

export default {
  name: "CommunityBell",
  props: {
    communityId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      notifications: [],
      loading: false
    };
  },
  computed: {
    ...mapState("community", ["unreadCount"]),
    unreadCountLabel() {
      return this.unreadCount > 9 ? "9+" : this.unreadCount;
    }
  },
  mounted() {
    this.fetchUnread();
  },
  methods: {
    timeFromNow,
    fetchUnread() {
      this.$store.dispatch("community/unreadCount", this.communityId);
    },
    onOpen() {
      this.loading = true;
      this.$store
        .dispatch("community/listNotifications", {
          id: this.communityId,
          limit: 20,
          offset: 0
        })
        .then(data => {
          this.notifications = data.results;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    describe(notification) {
      const actor = (notification.actor && notification.actor.name) || "Alguém";
      if (notification.notif_type === "reply_on_comment") {
        return `${actor} respondeu seu comentário`;
      }
      return `${actor} comentou na sua publicação`;
    },
    onClickNotification(notification) {
      if (notification.read_at) return;
      this.$store
        .dispatch("community/markRead", {
          id: this.communityId,
          ids: [notification.id]
        })
        .then(() => {
          notification.read_at = new Date().toISOString();
        });
    },
    markAllRead() {
      this.$store
        .dispatch("community/markRead", { id: this.communityId })
        .then(() => {
          this.notifications = this.notifications.map(notification => ({
            ...notification,
            read_at: notification.read_at || new Date().toISOString()
          }));
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.community-bell {
  .bell-button {
    position: relative;

    i {
      font-size: 22px;
    }

    .bullet {
      position: absolute;
      top: -6px;
      right: -8px;
      min-width: 16px;
      height: 16px;
      padding: 0 4px;
      border-radius: 8px;
      background: #ff757e;
      color: #fff;
      font-size: 10px;
      line-height: 16px;
      text-align: center;
    }
  }

  ::v-deep .bell-menu {
    min-width: 280px;
    max-width: 320px;
    max-height: 420px;
    overflow-y: auto;
  }

  .btn-link-action {
    border: none;
    background: transparent;
    padding: 0;
    color: inherit;
    font-size: 12px;
    opacity: 0.8;
  }

  .notification-item {
    white-space: normal;

    .dot {
      width: 8px;
      height: 8px;
      margin-top: 6px;
      border-radius: 50%;
      background: #ff757e;
      flex-shrink: 0;
    }

    p {
      font-size: 13px;
    }

    small {
      font-size: 11px;
      opacity: 0.7;
    }
  }

  .empty {
    font-size: 13px;
    opacity: 0.7;
  }
}
</style>
